const copyBtn = document.querySelector('#copy-button');
const tooltip = document.querySelector('.copyTooltip');

const TOGGLED_CLASS = 'copyTooltip--show';

if (copyBtn) {
    copyBtn.addEventListener('click', () => {
        const input = document.createElement('input');
        input.setAttribute('value', window.location.href);

        document.body.appendChild(input);

        input.select();

        document.execCommand('copy');
        document.body.removeChild(input);

        tooltip.classList.add(TOGGLED_CLASS);

        setTimeout(function () {
            tooltip.classList.remove(TOGGLED_CLASS);
        }, 1337);
    });
}
